(function ($, once, Drupal) {
  Drupal.behaviors.carousel_block = {
    attach(context) {
      // Adjusts rental prices for members.
      once('carousel_block', '[data-component-id="nuplayer:carousel_block"]', context).forEach(
        (carousel) => {
          $(document).on('carousel_block:update_prices', function () {
            const rentalFilmIds = [];
            // Get film ids for films in carousel.
            $(carousel)
              .find('a.film-card.pillar--rentals')
              .each(function () {
                rentalFilmIds.push($(this).data('film-id'));
              });
            if (rentalFilmIds.length > 0) {
              // Get the latest film content via the AJAX endpoint.
              const filmUtility = Drupal.behaviors.nuplayer.FilmUtility;
              filmUtility
                .fetchFilmPrices(rentalFilmIds)
                .then((filmPrices) => {
                  // Find and replace the prices.
                  for (const [filmId, price] of filmPrices.entries()) {
                    $(carousel).find(`[data-film-id="${filmId}"]`).find('.price').html(price);
                  }
                })
                .catch((error) => {
                  console.error('Error fetching film prices,', error);
                });
            }
          });
        }
      );
    },
  };
})(jQuery, once, Drupal);
